import React, { useState } from 'react';
import { Container, Title, Button, Switch } from "@bsf/force-ui";
import { Lock,  MoveUpRight } from "lucide-react";
import { __ } from '@wordpress/i18n';

const Branding = () => {
    const [settings, setSettings] = useState({
        author: '',
        author_url: '',
        plugin_name: '',
        short_name: '',
        description: '',
        hide_branding: false,
        logo_url: '',
        internal_help_links: false,
        replace_logo: false
    });

    const handleChange = (name, value) => {
        setSettings(prev => ({ ...prev, [name]: value }));
    };

    const handleSubmit = (e) => {
        e.preventDefault();
    };

    return (
        <form onSubmit={handleSubmit}>
            <div className="rounded-lg">

                {/* White Label title OUTSIDE */}
                <div
                    className="flex flex-row items-center justify-between"
                    style={{ paddingBottom: '24px' }}
                >
                    <Title
                        description=""
                        icon={null}
                        iconPosition="right"
                        size="sm"
                        tag="h2"
                        title={__('White Label', "header-footer-elementor")}
                    />
                </div>

                {/* Relative wrapper for overlay */}
                <div className="relative">

                    {/* Disabled content wrapper (NO visual change) */}
                    <div style={{ pointerEvents: 'none' }}>
                        <Container
                            align="stretch"
                            className="bg-background-primary p-6 rounded-lg"
                            containerType="flex"
                            direction="column"
                            gap="sm"
                            justify="start"
                            style={{ marginTop: "24px" }}
                        >
                            <div>
                                <Container
                                    align="stretch"
                                    className="flex flex-column bg-background-primary"
                                    containerType="flex"
                                    direction="column"
                                    style={{
                                        padding: "24px",
                                        borderRadius: "8px",
                                    }}
                                >
                                    <Title
                                        size="sm"
                                        tag="h2"
                                        title={__('Plugins Details', "header-footer-elementor")}
                                        description={__('You can change the author name and plugin details that are displayed in the WordPress backend.', "header-footer-elementor")}
                                    />

                                    <div className="flex flex-row items-center mt-1 w-full gap-3">
                                        <Container.Item className="flex flex-col space-y-1 basis-1/2 flex-1">
                                            <div className='text-base text-field-label font-semibold m-0 mb-2'>Author</div>
                                            <input
                                                name="author"
                                                type="text"
                                                value={settings.author}
                                                className='w-full border border-subtle px-2'
                                                onChange={(e) => handleChange(e.target.name, e.target.value)}
                                                placeholder={__('Brainstorm Force', "header-footer-elementor")}
                                                style={{
                                                    height: '48px',
                                                    borderColor: '#e0e0e0',
                                                    outline: 'none',
                                                    boxShadow: 'none',
                                                }}
                                                onFocus={(e) => e.target.style.borderColor = '#6005FF'}
                                                onBlur={(e) => e.target.style.borderColor = '#e0e0e0'}
                                            />
                                        </Container.Item>

                                        <Container.Item className="flex flex-col space-y-1 basis-1/2 flex-1">
                                            <div className='text-base text-field-label font-semibold m-0 mb-2'>Author URL</div>
                                            <input
                                                name="author_url"
                                                className='w-full border border-subtle px-2'
                                                type="url"
                                                value={settings.author_url}
                                                onChange={(e) => handleChange(e.target.name, e.target.value)}
                                                placeholder={__('https://www.brainstormforce.com', "header-footer-elementor")}
                                                style={{
                                                    height: '48px',
                                                    borderColor: '#e0e0e0',
                                                    outline: 'none',
                                                    boxShadow: 'none',
                                                }}
                                                onFocus={(e) => e.target.style.borderColor = '#6005FF'}
                                                onBlur={(e) => e.target.style.borderColor = '#e0e0e0'}
                                            />
                                        </Container.Item>
                                    </div>

                                    <div className="flex flex-row items-center mt-1 w-full gap-3">
                                        <Container.Item className="flex flex-col space-y-1 basis-1/2 flex-1">
                                            <div className='text-base text-field-label font-semibold m-0 mb-2'>{__('Plugin Name', "header-footer-elementor")}</div>
                                            <input
                                                name="plugin_name"
                                                type="text"
                                                className='w-full border border-subtle px-2'
                                                value={settings.plugin_name}
                                                onChange={(e) => handleChange(e.target.name, e.target.value)}
                                                placeholder={__('Ultimate Addons', "header-footer-elementor")}
                                                style={{
                                                    height: '48px',
                                                    borderColor: '#e0e0e0',
                                                    outline: 'none',
                                                    boxShadow: 'none',
                                                }}
                                                onFocus={(e) => e.target.style.borderColor = '#6005FF'}
                                                onBlur={(e) => e.target.style.borderColor = '#e0e0e0'}
                                            />
                                        </Container.Item>

                                        <Container.Item className="flex flex-col space-y-1 basis-1/2 flex-1">
                                            <div className='text-base text-field-label font-semibold m-0 mb-2'>{__('Plugin Short Name', "header-footer-elementor")}</div>
                                            <input
                                                name="short_name"
                                                type="text"
                                                className='w-full border border-subtle px-2'
                                                value={settings.short_name}
                                                onChange={(e) => handleChange(e.target.name, e.target.value)}
                                                placeholder={__('UAE', "header-footer-elementor")}
                                                style={{
                                                    height: '48px',
                                                    borderColor: '#e0e0e0',
                                                    outline: 'none',
                                                    boxShadow: 'none',
                                                }}
                                                onFocus={(e) => e.target.style.borderColor = '#6005FF'}
                                                onBlur={(e) => e.target.style.borderColor = '#e0e0e0'}
                                            />
                                        </Container.Item>
                                    </div>

                                    <Container.Item className="flex flex-col w-full space-y-1 space-x-2">
                                        <div className='text-base text-field-label font-semibold m-0'>{__('Plugin Description', "header-footer-elementor")}</div>
                                        <input
                                            name="description"
                                            type="text"
                                            className='w-full border border-subtle'
                                            value={settings.description}
                                            onChange={(e) => handleChange(e.target.name, e.target.value)}
                                            placeholder={__('Ultimate Addons is a premium extension for Elementor...', "header-footer-elementor")}
                                            style={{
                                                height: '48px',
                                                borderColor: '#e0e0e0',
                                                outline: 'none',
                                                boxShadow: 'none',
                                                marginTop: '16px'
                                            }}
                                            onFocus={(e) => e.target.style.borderColor = '#6005FF'}
                                            onBlur={(e) => e.target.style.borderColor = '#e0e0e0'}
                                        />
                                    </Container.Item>

                                    <div className='border border-subtle' style={{ height: '2px', backgroundColor: '#E5E7EB', marginTop: '6px' }} />

                                    <Container.Item className="flex flex-col w-full space-y-1 space-x-2">
                                        <div className='flex flex-row items-center justify-between px-1'>
                                            <Title
                                                size="xs"
                                                tag="h3"
                                                title={__('Replace or Hide Logo', "header-footer-elementor")}
                                                className="mt-4"
                                                description={__('Enable this option to hide the default logo or replace it with your own logo. (Note: To hide the logo, leave the logo URL field empty.)', "header-footer-elementor")}
                                            />
                                            <Switch
                                                onChange={(e) => handleChange('replace_logo', e)}
                                                size='md'
                                                value={settings.replace_logo}
                                                className="uael-remove-ring"
                                            />
                                        </div>
                                    </Container.Item>

                                    {settings.replace_logo && (
                                        <Container.Item className="flex flex-col w-full space-y-1 space-x-2">
                                            <div className='text-base text-field-label font-semibold m-0'>
                                                {__('Enter logo URL to replace', "header-footer-elementor")}
                                            </div>
                                            <input
                                                name="logo_url"
                                                type="url"
                                                className='w-full border border-subtle'
                                                value={settings.logo_url}
                                                onChange={(e) => handleChange(e.target.name, e.target.value)}
                                                placeholder={__('https://www.example.com/logo.svg', "header-footer-elementor")}
                                                style={{
                                                    height: '48px',
                                                    borderColor: '#e0e0e0',
                                                    outline: 'none',
                                                    boxShadow: 'none',
                                                    marginTop: '16px'
                                                }}
                                                onFocus={(e) => e.target.style.borderColor = '#6005FF'}
                                                onBlur={(e) => e.target.style.borderColor = '#e0e0e0'}
                                            />
                                        </Container.Item>
                                    )}

                                    <Container.Item className="flex flex-col w-full space-y-1 space-x-2">
                                        <div className='flex flex-row items-center justify-between px-1'>
                                            <Title
                                                size="xs"
                                                tag="h3"
                                                title={__('Hide White Label Settings', "header-footer-elementor")}
                                                className="mt-4"
                                                description={__('Enabling this option will hide the White Label settings. To access it again, re-activate the plugin.', "header-footer-elementor")}
                                            />
                                            <Switch
                                                onChange={(e) => handleChange('hide_branding', e)}
                                                size='md'
                                                value={settings.hide_branding}
                                            />
                                        </div>
                                    </Container.Item>

                                    <div className='border border-subtle' style={{ height: '2px', backgroundColor: '#E5E7EB', marginTop: '6px' }} />

                                    <Container.Item className="flex flex-col w-full space-y-1 space-x-2">
                                        <Title size="sm" tag="h2" title={__('Elementor Editor Area', "header-footer-elementor")} className="mt-1" />
                                        <div className='flex flex-row items-center justify-between px-1'>
                                            <Title
                                                size="xs"
                                                tag="h3"
                                                title={__('Show Help Links', "header-footer-elementor")}
                                                className="mt-4"
                                                description={__('Display internal help links in widget editor area.', "header-footer-elementor")}
                                            />
                                            <Switch
                                                onChange={(e) => handleChange('internal_help_links', e)}
                                                size='md'
                                                value={settings.internal_help_links}
                                            />
                                        </div>
                                    </Container.Item>

                                </Container>
                            </div>
                        </Container>
                    </div>

                    {/* Popup overlay */}
                    <div
                        className="absolute inset-0 z-20 flex items-center justify-center"
                        style={{ backgroundColor: 'rgba(255,255,255,0.6)' }}
                    >
                        <div
                            className="bg-white rounded-xl text-center"
                            style={{ width: 320, padding: '32px 28px', boxShadow: '-6px -6px 16px rgba(0,0,0,0.12), 12px 12px 30px rgba(0,0,0,0.18)', }}
                        >

                            <Lock size={32} className="text-gray-600" />
                            <h2 className="text-lg font-semibold mb-2">
                                {__('White Label Available in UAE Pro', "header-footer-elementor")}
                            </h2>

                            <p className="text-sm text-[#475569] mb-6">
                                {__('Remove UAE branding and customize the dashboard with your agency details.', "header-footer-elementor")}
                            </p>

                            <Button
                                variant="primary"
                                className='rounded-md'
                                style={{
                                    backgroundColor: "#6005FF",
                                    padding: '10px 22px',
                                }}
                                onClick={() =>
                                    window.open(
                                        'https://ultimateelementor.com/pricing/?utm_source=whitelabel&utm_medium=uaesettings',
                                        '_blank'
                                    )
                                }
                            >   
                               <span className='px-1'>{__('Upgrade Now', "header-footer-elementor")}</span>
                                <MoveUpRight  style={{
                                    width: "15px",
                                    height: '15px',
                                    marginBottom: '-2px',
                                    marginLeft: '2px',
                                }}/>
                            </Button>
                        </div>
                    </div>

                </div>
            </div>
        </form>
    );
};

export default Branding;
